import { useEventListener } from '@vueuse/core';
import { useHorizontalShadowManager } from '@/js/helpers/horizontalShadowManager';

const addShadowToStaticNavbar = () => {
    const CONTAINER_SELECTOR = '.static-navbar';
    const CONTENT_SELECTOR = '.router';
    const LEFT_SHADOW_CLASS = 'static-navbar-header-shadow--left--active';
    const RIGHT_SHADOW_CLASS = 'static-navbar-header-shadow--right--active';

    const BREAKPOINT = 678;

    useHorizontalShadowManager(
        CONTAINER_SELECTOR,
        CONTENT_SELECTOR,
        LEFT_SHADOW_CLASS,
        RIGHT_SHADOW_CLASS,
        BREAKPOINT,
    );
};

useEventListener(document, 'DOMContentLoaded', addShadowToStaticNavbar);
